'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _LoadingOutlined = _interopRequireDefault(require('./lib/icons/LoadingOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _LoadingOutlined;
exports.default = _default;
module.exports = _default;